import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as React from 'react';

import styles from './LookingToPayInvoicesTile.module.css';

const LookingToPayInvoicesTile = React.memo((): React.ReactElement => {
  const { enableNewOracleLink } = useFlags();
  const oracleRedirectUrl = enableNewOracleLink
    ? import.meta.env.VITE_ORACLE_OBM_REDIRECT_V2
    : import.meta.env.VITE_ORACLE_OBM_REDIRECT;

  return (
    <CobaltTile
      id="looking-to-pay-us-invoices-tile"
      className={styles.tile}
      data-testid="looking-to-pay-us-invoices-tile"
    >
      <div className={styles.textContent}>
        <span className={`heading-01 ${styles.tileHeading}`}>
          Looking to pay your US invoices?
        </span>
        <span className="body-02">
          Access Bills Management to pay your US invoices by credit card online.
        </span>
      </div>
      <div className={styles.urlContent}>
        <CobaltLink
          href={oracleRedirectUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.externalLink}
        >
          Go to Bills Management
          <CobaltIconExternalLinkOutline aria-hidden="true" />
        </CobaltLink>
      </div>
    </CobaltTile>
  );
});

LookingToPayInvoicesTile.displayName = 'LookingToPayInvoicesTile';
export { LookingToPayInvoicesTile };
